
export default class FormItemDateDisplay
{
	static defaultSep = "-";
	static defaultNumOfYear = 4;
	static defaultNumOfDay = 2;
	static defaultNumOfMonth = 2;
	
	static getDisplayText(value,show1970,seperator,numOfDay,numOfMonth,numOfYear)
	{
		if(value == null)
		{
			return "";
		}
		else if(value == "")
		{
			return "";
			if(show1970)
				return "1970-01-01";
			else
				return "";
		}
		/*else if(value == "1970-01-01")
		{
			if(show1970 == false)
				return "";
			else
				return value;
		}*/
		else
		{
			var array = value.split("");
			var result = "";
			var sep = seperator;
			
			var numDay = numOfDay;
			var day = numDay;
			var numMonth = numOfMonth;
			var month = numMonth;
			var numYear = numOfYear;
			var year = numYear;
			var ptr = array.length - 1;
			
			
			while(numDay>0)
			{
				result = array[ptr] + result;
				//formatString += "D";
				numDay --;
				ptr --;
			}
			
			if(day == 1)
			{
				var c = array[ptr];
				if(c != "0")
					result = c + result;
			}
			
			if(month > 0 &&  day > 0)
			{
				result = sep + result;
			}
			
			ptr = array.length - 4;
			
			while(numMonth > 0)
			{
				result = array[ptr] + result;
				numMonth --;
				ptr --;
			}
			
			if(month == 1)
			{
				c = array[ptr];
				if(c != "0")
					result = c + result;
			}
			
			if( year > 0 && (day>0||month>0))
			{
				result = sep + result;
			}
			
			ptr = array.length - 7;
			
			while(numYear > 0)
			{
				result = array[ptr] + result;
				numYear --;
				ptr --;
			}
			
			return result;
		}
	
	}

	static getDisplayText2(value,displayFormat)
	{
		if(!value)return value;
		let date = new Date(value);
		return FormItemDateDisplay.dateFormat2(displayFormat,date);//date.format(displayFormat);
	}

	
	static dateFormat2(fmt,date)
	{
		var o = {
			"M+": date.getMonth() + 1, //月份 
			"D+": date.getDate(), //日 
			"h+": date.getHours(), //小时 
			"m+": date.getMinutes(), //分 
			"s+": date.getSeconds(), //秒 
			"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
			"S": date.getMilliseconds() //毫秒 
		};
		if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/display/FormItemDateDisplay.js